export default __webpack_public_path__ + "static/media/rocky6.47d5b1ff.webp";